// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as URLUtils$Showside from "../utils/URLUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function getPathname(url) {
  try {
    return Belt_Option.map(Belt_Option.map(URLUtils$Showside.maybeMakeUrl(url), function (prim) {
      return prim.pathname;
    }), function (prim) {
      return prim.toLowerCase();
    });
  } catch (exn) {
    return;
  }
}
function getRootForCLP(urlPathname, topLevelCategories) {
  if (urlPathname === "/") {
    return;
  }
  var l1Match = topLevelCategories.find(function (cat) {
    if (!(!Category$Showside.isQuickView(cat) && !Category$Showside.isLinkCategory(cat) && !Category$Showside.hasMedialessCard(cat))) {
      return false;
    }
    var link = Category$Showside.getCategoryLink(cat);
    if (link !== undefined) {
      return Caml_obj.equal(urlPathname.toLowerCase(), getPathname(link));
    } else {
      return false;
    }
  });
  var l1Match$1 = l1Match === undefined ? undefined : Caml_option.some(l1Match);
  var l2OrDeeperMatch = Category$Showside.findCategoryBy(topLevelCategories, function (cat) {
    if (!(!Category$Showside.isQuickView(cat) && !Category$Showside.isLinkCategory(cat) && !Category$Showside.hasMedialessCard(cat))) {
      return false;
    }
    var match = Category$Showside.getCategoryLink(cat);
    if (l1Match !== undefined) {
      if (match !== undefined && Caml_obj.equal(urlPathname.toLowerCase(), getPathname(match))) {
        return l1Match.id !== cat.id;
      } else {
        return false;
      }
    } else if (match !== undefined) {
      return Caml_obj.equal(urlPathname.toLowerCase(), getPathname(match));
    } else {
      return false;
    }
  });
  if (l2OrDeeperMatch !== undefined) {
    return l2OrDeeperMatch;
  } else {
    return l1Match$1;
  }
}
function getParentSiblings(topLevelCategories, category) {
  return Category$Showside.getCategoryParentById(topLevelCategories, category.id);
}
function fallbackIfEmpty(categories, fallback) {
  if (Belt_Array.keep(categories, function (category) {
    return category.visibleInMenuBar;
  }).length === 0) {
    return fallback;
  } else {
    return categories;
  }
}
function useContextualRoot(drawerState, embedType, urlPathname) {
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var canUseContextualL1s = embedType !== /* Inline */1 && settings.contextualL1s && drawerState !== /* Open */2 || settings.contextualInline && embedType === /* Inline */1;
  if (canUseContextualL1s) {
    return getRootForCLP(urlPathname, match.categories);
  }
}
function useContextualL1s(embedType, drawerState, urlPathname) {
  var hasNavigatedAwayFromContextualRoot = React.useRef(false);
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var topLevelCategories = match.categories;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, topLevelCategories);
  var canUseContextualL1s = (embedType === /* Bottombar */0 || embedType === /* Launcher */2) && match.settings.contextualL1s && drawerState !== /* Open */2;
  if (!canUseContextualL1s) {
    return topLevelCategories;
  }
  var contextualRoot = getRootForCLP(urlPathname, topLevelCategories);
  var isInRootsOrParentPath;
  if (contextualRoot !== undefined) {
    var isRootPLP = Category$Showside.isPLP(contextualRoot);
    var inRootsPath = Belt_Option.mapWithDefault(activeCategory, [], function (activeCat) {
      return Category$Showside.getCategoryPathById(topLevelCategories, activeCat.id);
    }).some(function (cat) {
      return cat.id === contextualRoot.id;
    });
    if (inRootsPath) {
      isInRootsOrParentPath = true;
    } else {
      var tmp = false;
      if (isRootPLP) {
        var rootParent = Category$Showside.getCategoryParentById(topLevelCategories, contextualRoot.id);
        tmp = Belt_Option.mapWithDefault(activeCategory, [], function (activeCat) {
          return Category$Showside.getCategoryPathById(topLevelCategories, activeCat.id);
        }).some(function (cat) {
          return cat.id === Belt_Option.mapWithDefault(rootParent, "", function (parent) {
            return parent.id;
          });
        });
      }
      isInRootsOrParentPath = tmp;
    }
  } else {
    isInRootsOrParentPath = false;
  }
  if (!isInRootsOrParentPath && drawerState === /* Open */2) {
    hasNavigatedAwayFromContextualRoot.current = true;
  }
  if (drawerState === /* Closed */0) {
    hasNavigatedAwayFromContextualRoot.current = false;
  }
  var canUseContextualL1s$1 = canUseContextualL1s && (drawerState === /* Closed */0 || isInRootsOrParentPath) && (drawerState === /* Closed */0 || !hasNavigatedAwayFromContextualRoot.current);
  if (contextualRoot === undefined) {
    return topLevelCategories;
  }
  if (!canUseContextualL1s$1) {
    return topLevelCategories;
  }
  var match$1 = contextualRoot.listPageActiveLayout;
  var isPLP;
  isPLP = typeof match$1 === "number" || match$1.TAG !== /* ProductGrid */3 ? false : true;
  if (isPLP) {
    return fallbackIfEmpty(Belt_Option.mapWithDefault(Category$Showside.getCategoryParentById(topLevelCategories, contextualRoot.id), topLevelCategories, Category$Showside.getChildren), topLevelCategories);
  } else {
    return fallbackIfEmpty(Category$Showside.getChildren(contextualRoot), topLevelCategories);
  }
}
export { getPathname, getRootForCLP, getParentSiblings, fallbackIfEmpty, useContextualRoot, useContextualL1s };
/* react Not a pure module */